import { Link } from 'react-router-dom'
import { useTheme } from '@mfox/shared/lib/useTheme'
import logoFull from '../../assets/logo-full.png'
import logoFullDark from '../../assets/logo-full-dark.png'
import './Logo.css'

export interface LogoProps {
  /** Makes the logo a link, usually home ("/"). */
  to?: string
  size?: 'md' | 'lg'
  className?: string
}

/** The MentorFox logo (fox mark and "mentor fox" wordmark), with the white-text artwork in the dark theme. */
export function Logo({ to, size = 'md', className }: LogoProps) {
  const { theme } = useTheme()
  const classes = ['logo', `logo--${size}`, className].filter(Boolean).join(' ')
  const img = <img className="logo__img" src={theme === 'dark' ? logoFullDark : logoFull} alt="MentorFox" />

  return to ? (
    <Link to={to} className={classes}>
      {img}
    </Link>
  ) : (
    <span className={classes}>{img}</span>
  )
}
